// extracted by mini-css-extract-plugin
export default {"delete":"ButtonDeleteUI_delete__ZoJnq"};